export const PAPER_UPLOAD_STATES = {
  start: 'start',
  end: 'end',
}

export const EVENT_TYPES = {
  PAGEVIEW: 'pageview',
  PAPER_UPLOAD: 'paperUpload',
}

export const ALLOCATION_MAP_KEY = 'allocationMap'

export const PAGE_TYPE = 'upload lp'
